import { render, staticRenderFns } from "./StatusHistory.vue?vue&type=template&id=bfc2fc7c&scoped=true"
import script from "./StatusHistory.vue?vue&type=script&lang=js"
export * from "./StatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc2fc7c",
  null
  
)

export default component.exports